<template>
  <div>
    <div>
      <div class="section">
        <div class="section_image">
          <div>
            <!--  -->

            <div class="image-preview" v-if="imageData[0] != undefined">
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(0)"></div>
              </div>
              <img
                v-if="
                  imageData[0].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                class="container"
                :src="`${imageData[0]}.webp`"
                id="faceLadoFixoPreviewEdit"
                @click="clickPreview(imageData[0])"
              />
              <img
                v-else
                class="container"
                :src="`${imageData[0]}`"
                id="faceLadoFixoPreviewEdit"
                @click="clickPreview(imageData[0])"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="fotoEmbalagem8"
                  @change="previewFiles($event, 0)"
                  multiple
                  hidden
                />
                <label class="palavra" for="fotoEmbalagem8">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>

            <!--  -->
            <div>
              <p class="title">Face do Lado Fixo</p>
              <div class="icons">
                <div class="btn-group" v-if="imageData[0] != undefined">
                  <label
                    class="botao-editar"
                    for="FotodaFacedoLadoFixoPreviewEdit"
                  ></label>
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    @change="previewFiles($event, 0)"
                    id="FotodaFacedoLadoFixoPreviewEdit"
                    name="FotodaFacedoLadoFixoPreview"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section_image">
          <div>
            <!--  -->

            <div class="image-preview" v-if="imageData[1] != undefined">
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(1)"></div>
              </div>
              <img
                v-if="
                  imageData[1].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                class="container"
                :src="`${imageData[1]}.webp`"
                id="fotoLadoMovelPreviewEdit"
                @click="clickPreview(imageData[1])"
              />
              <img
                v-else
                class="container"
                :src="`${imageData[1]}`"
                id="fotoLadoMovelPreviewEdit"
                @click="clickPreview(imageData[1])"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="fotoEmbalagem9"
                  @change="previewFiles($event, 1)"
                  multiple
                  hidden
                />
                <label class="palavra" for="fotoEmbalagem9">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>

            <!--  -->

            <div>
              <p class="title">Face do Lado Móvel</p>
              <div class="icons">
                <div class="btn-group" v-if="imageData[1] != undefined">
                  <label
                    class="botao-editar"
                    for="FotodaFacedoLadoMovelPreviewEdit"
                  ></label>

                  <input
                    type="file"
                    hidden
                    @change="previewFiles($event, 1)"
                    id="FotodaFacedoLadoMovelPreviewEdit"
                    accept="image/*"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section_image">
          <div>
            <!--  -->
            <div class="image-preview" v-if="imageData[2] != undefined">
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(2)"></div>
              </div>
              <img
                v-if="
                  imageData[2].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                class="container"
                :src="`${imageData[2]}.webp`"
                id="extraPreviewEdit"
                @click="clickPreview(imageData[2])"
              />
              <img
                v-else
                class="container"
                :src="`${imageData[2]}`"
                id="extraPreviewEdit"
                @click="clickPreview(imageData[2])"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="fotoEmbalagem10"
                  @change="previewFiles($event, 2)"
                  multiple
                  hidden
                />
                <label class="palavra" for="fotoEmbalagem10">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>

            <!--  -->
            <div class="card-body">
              <div>
                <div>
                  <input
                    type="text"
                    class="extra-input"
                    v-model="FormDataImages.fotoMoldeAbertoExtra.description"
                    placeholder="Insira um título"
                  />
                </div>
                <div class="btn-group" v-if="imageData[2] != undefined">
                  <label
                    class="botao-editar"
                    for="fotoMoldeAbertoExtraPreviewEdit"
                  ></label>
                  <input
                    type="file"
                    hidden
                    id="fotoMoldeAbertoExtraPreviewEdit"
                    @change="previewFiles($event, 2)"
                    accept="image/*"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputI1 from "../../../../../Inputs-defaults/Inp-1.vue";
export default {
  components: { InputI1 },
  props: {
    configInputs: Number,
  },
  async created() {
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  data() {
    return {
      imageData: [],

      FormDataImages: {
        FotodaFacedoLadoFixoFile: [],
        FotodaFacedoLadoMovelFile: [],
        fotoMoldeAbertoExtra: {
          file: [],
          description: "",
        },
      },
    };
  },

  watch: {
    FormDataImages: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.$store.commit("MutationImagesMoldeAberto", newValue);
      },
    },
  },
  methods: {
    clickPreview(base64) {
      this.$swal
        .fire({
          imageUrl: base64,
          imageAlt: "Imagem carregada",
          confirmButtonText: "Baixar",
          showCloseButton: true,
          background: "#fff",
          customClass: {
            popup: "preview-modal-popup",
            image: "preview-modal-image",
            confirmButton: "preview-modal-button",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            const link = document.createElement("a");
            link.href = base64;
            link.download = "imagem.jpg";
            link.click();
          }
        });
    },
    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;

      if (dataQuery.ImagesRRIM[0].IMG_MA_F_L_FIXO) {
        this.imageData[0] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MA_F_L_FIXO}`;
        this.FormDataImages.FotodaFacedoLadoFixoFile =
          dataQuery.ImagesRRIM[0].IMG_MA_F_L_FIXO;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MA_F_L_MOVEL) {
        this.imageData[1] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MA_F_L_MOVEL}`;
        this.FormDataImages.FotodaFacedoLadoMovelFile =
          dataQuery.ImagesRRIM[0].IMG_MA_F_L_MOVEL;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MA_EXTRA) {
        this.imageData[2] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MA_EXTRA}`;
        this.FormDataImages.fotoMoldeAbertoExtra.file =
          dataQuery.ImagesRRIM[0].IMG_MA_EXTRA;
      }

      if (dataQuery.ImagesRRIM[0].IMG_MA_EXTRA_DESC) {
        this.FormDataImages.fotoMoldeAbertoExtra.description =
          dataQuery.ImagesRRIM[0].IMG_MA_EXTRA_DESC;
      }
    },

    previewFiles(event, position) {
      // Referência ao elemento de entrada DOM
      var input = event.target;
      if (input.files && input.files[0]) {
        const file = input.files[0];

        if (!file.type.startsWith("image/")) {
          this.$swal.fire({
            icon: "error",
            title: "Arquivo inválido",
            text: "Por favor, selecione apenas arquivos de imagem.",
            confirmButtonColor: "#e74c3c",
          });
          input.value = "";
          return;
        }
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // crie um novo FileReader para ler esta imagem e converter para o formato base64
        reader.onload = (e) => {
          // Note: função de seta usada aqui, de modo que "this.imageData" se refira ao componente imageData do Vue
          // Leia a imagem como base64 e defina como imageData
          this.imageData[position] = e.target.result;

          //Acionar $Emit para enviar o objeto quando um File for adicionado
        };
      }
      // Inicie o trabalho do leitor - leia o arquivo como url de dados (formato base64)
      reader.readAsDataURL(input.files[0]);
      // Certifique-se de que possui um arquivo antes de tentar lê-lo
      if (input.files && input.files[0]) {
        //Identificando em qual contexto a imagem se encaixa
        switch (position) {
          case 0:
            this.FormDataImages.FotodaFacedoLadoFixoFile = input.files[0];
            break;
          case 1:
            this.FormDataImages.FotodaFacedoLadoMovelFile = input.files[0];
            break;
          case 2:
            this.FormDataImages.fotoMoldeAbertoExtra.file = input.files[0];

            break;
        }
        // this.$emit("setFotosAbertEmb",this.FormDataImages)
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // crie um novo FileReader para ler esta imagem e converter para o formato base64
        reader.onload = (e) => {
          // Note: função de seta usada aqui, de modo que "this.imageData" se refira ao componente imageData do Vue
          // Leia a imagem como base64 e defina como imageData
          this.imageData[position] = e.target.result;
        };
        // Inicie o trabalho do leitor - leia o arquivo como url de dados (formato base64)
        reader.readAsDataURL(input.files[0]);

        //Acionar $Emit para enviar o objeto quando um File for adicionado
      }
    },

    resetFile(position) {
      this.imageData[position] = null;

      switch (position) {
        case 0:
          this.FormDataImages.FotodaFacedoLadoFixoFile = [];
          break;
        case 1:
          this.FormDataImages.FotodaFacedoLadoMovelFile = [];
          break;
        case 2:
          this.FormDataImages.fotoMoldeAbertoExtra.file = [];
          this.FormDataImages.fotoMoldeAbertoExtra.description = "";
          break;
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.container {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Faz o "zoom" sem distorcer */
  border-radius: 1rem;
  cursor: pointer;
}

.image-preview,
.palavra1,
#fotoEmbalagemPreview {
  width: 12rem !important;
  height: 12rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  overflow: hidden;
}

#fotoEmbalagemPreview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 1rem;
}

.section {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.section_image {
  display: inline-block;
  max-width: 12rem !important;
}

.title {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  margin-top: 0.5rem;
}

.palavra {
  width: 12rem !important;
}

.botao-editar {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: white;
  background-image: url(../../../../../../static/icons/photo_camera_dark.svg) !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 70%;
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-family: "Poppins", sans-serif;
  width: 3rem;
  height: 3rem;
  border: 3px solid var(--font_color);
}

.botao-editar:hover {
  background-color: var(--font_color);
  border: none;
  background-image: url(../../../../../../static/icons/photo_camera_white.svg) !important;
}

.palavra1 {
  background-color: var(--bgProcess);
  background-image: url(../../../../../../static/icons/+_black.svg);
  width: 12rem !important;
  height: 12rem !important;
  border-radius: 1rem;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 15%;
}

.palavra1:hover {
  background-color: rgb(156, 150, 150);
}

.image-preview {
  position: relative;
}

.removeimage {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 3;
  cursor: pointer;
}

#fotoEmbalagemPreview {
  position: relative;
  z-index: 2;
  border-radius: 1rem;
}

.closeimage {
  width: 24px;
  height: 24px;
  background: url(../../../../../../static/icons/closeimage.svg) no-repeat
    center;
  background-size: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  cursor: pointer;
}

.extra-input {
  background-color: rgba(255, 255, 255, 0);
  padding: 0 !important;
  height: 1rem !important;
  border: none !important;
  color: var(--font_color);
  font-weight: 600;
  font-family: "Poppins", "sans-serif";
  border: 1px solid red;
}

.empty {
  background-image: url("../../../../../../static/icons/empty-image.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 40%;
  width: 12rem;
  height: 12rem;
  border: 2px solid #757575;
  border-radius: 1rem;
}

@media (max-width: 1266px) {
  .image-preview,
  .palavra1,
  #fotoEmbalagemPreview,
  .empty {
    width: 11rem !important;
    height: 11em !important;
  }
}

@media (max-width: 883px) {
}

@media (max-width: 500px) {
  .image-preview,
  .palavra1,
  #fotoEmbalagemPreview {
    width: 12rem !important;
    height: 12rem !important;
  }
}
</style>
